export const titleData = {
  m1: '一腔热血不灭，不负故乡良月',
  m2: '初心不忘，天生要强',
  m3: '心有所向，自带光芒',
  m4: '魂有所寄，心有所依',
  m5: '步履坚实，内心坦荡',
  f1: '做得完工作，爱不完生活',
  f2: '和希望并肩，与热爱同行',
  f3: '被生活温柔以待',
  f4: '日渐成熟，不忘天真',
  f5: '生活总有新奇',
  f6: '有好风景，也有小确幸'
}
